export default __webpack_public_path__ + "1de771aaf1ee2fa157c4d8ac363fff05.png";